export async function authFetch(url: string, options: any = {}, accessToken: string | null, setUserAndToken: (user: any, token: string) => void) {
  const opts = { ...options, headers: { ...(options.headers || {}) } };
  if (accessToken) {
    opts.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  opts.credentials = "include";
  let response = await fetch(url, opts);
  if (response.status === 401) {
    // Try to refresh
    const refreshResp = await fetch((process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:8000") + "/api/v1/admin/refresh", {
      method: "POST",
      credentials: "include",
    });
    if (refreshResp.ok) {
      const data = await refreshResp.json();
      setUserAndToken(data.user, data.access_token || "");
      opts.headers["Authorization"] = `Bearer ${data.access_token}`;
      response = await fetch(url, opts);
    } else {
      setUserAndToken(null, "");
    }
  }
  return response;
} 